export default __webpack_public_path__ + "static/shmuela-jacobs-4da908de34defbba801872b665208370.jpg";